<header class="dialog-title">
  <span>{{ 'driver.' + (state  === driverState.ADD ? 'new' : 'edit') | translate }}</span>
</header>

<div class="image-and-form">
  <div class="image-box">
    <img [src]="driver?.avatarUrl" alt="driver-avatar">

    <button mat-icon-button
      class="random-button"
      (click)="changeAvatarRandom()">
      <mat-icon>casino</mat-icon>
    </button>

    <button mat-icon-button
      class="edit-button"
      (click)="changeAvatarManually()">
      <mat-icon>edit</mat-icon>
    </button>
  </div>

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-container">
        <div [formGroupName]="control.NESTED_GROUP"
          class="nested-form-group"
          [ngClass]="{'group-error': formControl[control.NESTED_GROUP].errors?.nameIsUsed}">
          <mat-form-field>
            <mat-label>{{ 'driver.last-name' | translate }}</mat-label>
            <input matInput
              placeholder="{{ 'driver.last-name' | translate }}"
              formControlName="{{ control.LAST_NAME }}">
              @if (fullNameFormControl[control.LAST_NAME].errors?.required) {
                <mat-error>
                  {{ 'message.error.can-not-be-empty' | translate }}
                </mat-error>
              }
              @if (fullNameFormControl[control.LAST_NAME].errors?.minlength) {
                <mat-error>
                  {{ 'message.error.min-length-symbols' | translate:
                  {min: asLengthError(fullNameFormControl[control.LAST_NAME].errors.minlength).requiredLength} }}
                </mat-error>
              }
              @if (fullNameFormControl[control.LAST_NAME].errors?.maxlength) {
                <mat-error>
                  {{ 'message.error.max-length-symbols' | translate:
                  {max: asLengthError(fullNameFormControl[control.LAST_NAME].errors.maxlength).requiredLength} }}
                </mat-error>
              }
              @if (fullNameFormControl[control.LAST_NAME].errors?.pattern) {
                <mat-error>
                  {{ 'message.error.contains-illegal-symbols' | translate }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'term.name' | translate }}</mat-label>
              <input matInput
                placeholder="{{ 'term.name' | translate }}"
                formControlName="{{ control.FIRST_NAME }}">
                @if (fullNameFormControl[control.FIRST_NAME].errors?.minlength) {
                  <mat-error>
                    {{ 'message.error.min-length-symbols' | translate:
                    {min: asLengthError(fullNameFormControl[control.FIRST_NAME].errors.minlength).requiredLength} }}
                  </mat-error>
                }
                @if (fullNameFormControl[control.FIRST_NAME].errors?.maxlength) {
                  <mat-error>
                    {{ 'message.error.max-length-symbols' | translate:
                    {max: asLengthError(fullNameFormControl[control.FIRST_NAME].errors.maxlength).requiredLength} }}
                  </mat-error>
                }
                @if (fullNameFormControl[control.FIRST_NAME].errors?.pattern) {
                  <mat-error>
                    {{ 'message.error.contains-illegal-symbols' | translate }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'driver.middle-name' | translate }}</mat-label>
                <input matInput
                  placeholder="{{ 'driver.middle-name' | translate }}"
                  formControlName="{{ control.MIDDLE_NAME }}">
                  @if (fullNameFormControl[control.MIDDLE_NAME].errors?.minlength) {
                    <mat-error>
                      {{ 'message.error.min-length-symbols' | translate:
                      {min: asLengthError(fullNameFormControl[control.MIDDLE_NAME].errors.minlength).requiredLength} }}
                    </mat-error>
                  }
                  @if (fullNameFormControl[control.MIDDLE_NAME].errors?.maxlength) {
                    <mat-error>
                      {{ 'message.error.max-length-symbols' | translate:
                      {max: asLengthError(fullNameFormControl[control.MIDDLE_NAME].errors.maxlength).requiredLength} }}
                    </mat-error>
                  }
                  @if (fullNameFormControl[control.MIDDLE_NAME].errors?.pattern) {
                    <mat-error>
                      {{ 'message.error.contains-illegal-symbols' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
                @if (formControl[control.NESTED_GROUP].errors?.nameIsUsed) {
                  <mat-error>
                    {{ 'message.error.full-name-already-exist' | translate }}
                  </mat-error>
                }
              </div>
              <mat-form-field>
                <mat-label>{{ 'unit.phone-number' | translate }}</mat-label>
                <input matInput
                  placeholder="+375297775566"
                  formControlName="{{ control.PHONE }}">
                  @if (formControl[control.PHONE].errors?.pattern) {
                    <mat-error>
                      {{ 'message.error.invalid-phone-number' | translate }}
                    </mat-error>
                  }
                  @if (formControl[control.PHONE].errors?.nameIsUsed) {
                    <mat-error>
                      {{ 'message.error.already-exist' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </form>
          }
        </div>

        <div class="flex flex-gap12 flex-justify-center">
          <button mat-button class="app-button stroked" (click)="onCancel()">{{ 'action.cancel' | translate }}</button>
          <button mat-button class="app-button primary"
            [disabled]="driver?.avatarUrl === DEFAULT_AVATAR || form?.pristine || form?.invalid || form?.pending"
            (click)="onSubmit()">
            {{ 'action.save' | translate }}
          </button>
        </div>
